import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Package } from '../models/packages/package.model';
import { TemplateCustomField } from '../models/packages/templateCustomField.model';

@Injectable({
  providedIn: 'root'
})
export class EAndOCommonService {

  
  private archiveTabReload = new Subject<void>();
  archiveTabReloadReloadObs = this.archiveTabReload.asObservable();

  notifyArchiveTabToReload() {
    this.archiveTabReload.next();
  }

  private activeTabReload = new Subject<void>();
  activeTabReloadReloadObs = this.activeTabReload.asObservable();

  notifyActiveTabToReload() {
    this.activeTabReload.next();
  }

  constructor() {

  }

}
